/* Aquamentor: Two-Sided Print Setup fee (Dan 2026-10-10). Generated by tools/build.py --web (tools/web_build.py); rebuild, do not edit in the theme.
   Rule: while any cart line prints 2+ sides ("Sides to print" = "2 (...)" from the 3D bridge, or an Easify "Print a second side" tick),
   the cart holds exactly ONE setup line with quantity 1; when the last such line goes, the setup line goes too.
   Config: window.AQ3D_TWOSIDE_CFG (snippets/aq3d-twoside.liquid): section setting variant id > Liquid handle lookup > /products/<handle>.js. */
(function () {
  if (window.__aq3dTwosideLoaded) return;
  window.__aq3dTwosideLoaded = true;
  var cfgs = window.AQ3D_TWOSIDE_CFG || [], cfg = { variant: '', handle: 'second-side-print-setup', price: '' }, i;
  for (i = 0; i < cfgs.length; i++) if (cfgs[i] && cfgs[i].explicit && cfgs[i].variant) { cfg.variant = String(cfgs[i].variant); break; }
  for (i = 0; i < cfgs.length; i++) {
    var c = cfgs[i] || {};
    if (!cfg.variant && c.variant) cfg.variant = String(c.variant);
    if (c.handle && (i === 0 || c.explicit)) cfg.handle = String(c.handle);
    if (!cfg.price && c.price) cfg.price = String(c.price);
  }
  cfg.variant = cfg.variant.replace(/\D/g, '');
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var nativeFetch = window.fetch.bind(window);
  var api = window.aq3dTwoside = { active: !!cfg.variant, price: cfg.price, variant: cfg.variant, handle: cfg.handle, reconcile: function () { return reconcile(); } };

  var vidP = null;
  function variantId() {                              // '' = no setup product: the whole feature stays off
    if (vidP) return vidP;
    if (cfg.variant) return (vidP = Promise.resolve(cfg.variant));
    vidP = nativeFetch(root + 'products/' + encodeURIComponent(cfg.handle) + '.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (p) {
        var v = p && p.variants && p.variants[0]; if (!v) return '';
        cfg.variant = api.variant = String(v.id); api.active = true;
        if (!cfg.price && typeof v.price === 'number') api.price = cfg.price = '$' + (v.price % 100 ? (v.price / 100).toFixed(2) : String(v.price / 100));
        return cfg.variant;
      }, function () { return ''; });
    return vidP;
  }
  function isSetup(it) { return (cfg.variant && String(it.variant_id) === cfg.variant) || (!!cfg.handle && it.handle === cfg.handle); }
  function sidesOf(it) {                              // number of printed sides this line asks for (0 = unknown / one side)
    var p = it.properties || {}, n = 0;
    for (var k in p) {
      if (!Object.prototype.hasOwnProperty.call(p, k)) continue;
      var key = String(k).trim().toLowerCase(), v = p[k] == null ? '' : String(p[k]).trim();
      if (key === 'sides to print') { var m = /^(\d+)/.exec(v); if (m) n = Math.max(n, +m[1]); }
      else if (key === 'print a second side' && v && !/^(no|false|0|off|none)$/i.test(v)) n = Math.max(n, 2);
    }
    return n;
  }
  function post(path, body) {
    return nativeFetch(root + path, { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: JSON.stringify(body) })
      .then(function (r) { if (!r.ok) throw new Error(path + ' ' + r.status); return r.json(); });
  }
  function getCart() {
    return nativeFetch(root + 'cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' }, cache: 'no-store' })
      .then(function (r) { if (!r.ok) throw new Error('cart.js ' + r.status); return r.json(); });
  }
  // One pass: read the cart, decide, make the smallest change. Returns true when the cart changed.
  function pass() {
    return getCart().then(function (cart) {
      var items = cart.items || [], need = false, setup = [];
      for (var j = 0; j < items.length; j++) {
        if (isSetup(items[j])) setup.push(items[j]); else if (sidesOf(items[j]) >= 2) need = true;
      }
      if (!need && !setup.length) return false;
      if (need && setup.length === 1 && setup[0].quantity === 1) return false;
      var ops = [];
      if (!need) setup.forEach(function (s) { ops.push({ id: s.key, quantity: 0 }); });   // last two-sided line gone: drop the fee
      else if (setup.length) setup.forEach(function (s, k) {                               // keep one line at qty 1, drop duplicates
        var q = k === 0 ? 1 : 0; if (s.quantity !== q) ops.push({ id: s.key, quantity: q });
      });
      if (ops.length) return ops.reduce(function (pr, op) { return pr.then(function () { return post('cart/change.js', op); }); }, Promise.resolve()).then(function () { return true; });
      return variantId().then(function (vid) {
        if (!vid) return false;
        return post('cart/add.js', { items: [{ id: +vid, quantity: 1, properties: { _aq3d_auto: 'two-sided setup' } }] }).then(function () { return true; });
      });
    });
  }
  // Easify may add this same product itself (its $35 option, qty = units): the pass treats those lines like any other setup line and
  // sets the first one to qty 1 / drops the rest. If something keeps re-adding, each pass only resets it; after 8 changes in 20 s
  // the script stops changing the cart for this page view rather than ping-pong with another app.
  var busy = null, again = false, timer = null, edits = [];
  function reconcile() {
    if (busy) { again = true; return busy; }
    var now = Date.now(); edits = edits.filter(function (t) { return now - t < 20000; });
    if (edits.length >= 8) { if (window.console) console.warn('aq3d two-sided setup: too many cart changes, pausing'); return Promise.resolve(); }
    var changed = false;
    busy = pass().then(function (ch) { changed = ch; }, function (e) { if (window.console) console.warn('aq3d two-sided setup:', e && e.message || e); })
      .then(function () {
        busy = null;
        if (changed) { edits.push(Date.now()); refreshUi(); }
        if (again || changed) { again = false; return reconcile(); }   // re-check after our own change: converges in one extra read
      });
    return busy;
  }
  function schedule() { clearTimeout(timer); timer = setTimeout(reconcile, 250); }
  // Taiga: <cart-items> (cart page + drawer) re-renders the main-cart section; header blip listens to cart:update.
  function refreshUi() {
    var els = document.querySelectorAll('cart-items'), done = false;
    if (els.length) {
      nativeFetch(root + 'cart?section_id=main-cart', { credentials: 'same-origin' }).then(function (r) { return r.text(); }).then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        for (var k = 0; k < els.length; k++) if (typeof els[k].updateCartSections === 'function') { els[k].updateCartSections(doc); done = true; }
        if (!done && /\/cart\/?$/.test(location.pathname)) location.reload();
      }, function () {});
    } else if (/\/cart\/?$/.test(location.pathname)) location.reload();
    try { document.dispatchEvent(new CustomEvent('aq3d:twoside', { detail: {} })); } catch (e) {}
    try { document.dispatchEvent(new CustomEvent('cart:update', { detail: { aq3d: true } })); } catch (e) {}
  }
  // Watch every cart change made by the theme, Easify or anything else.
  var CART_RE = /\/cart\/(add|change|update|clear)(\.js|\.json)?(\?|$)/;
  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || String(input || ''), pr = nativeFetch(input, init);
    if (CART_RE.test(url)) pr.then(schedule, function () {});
    return pr;
  };
  var xo = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (m, url) {
    if (CART_RE.test(String(url || ''))) this.addEventListener('loadend', schedule);
    return xo.apply(this, arguments);
  };
  ['ajaxProduct:added', 'cart:update', 'cart:updated', 'cart:refresh'].forEach(function (ev) {
    document.addEventListener(ev, function (e) { if (!(e.detail && e.detail.aq3d)) schedule(); });
  });
  window.addEventListener('pageshow', schedule);
  if (!cfg.variant && document.querySelector('iframe[data-aq3d]')) variantId();   // product page note needs to know the fee exists
  schedule();
})();
